export default {
    GET_ALL_BANNER_MAIN: 'GET_ALL_BANNER_MAIN',
    UPDATE_ORDER_BANNER: 'UPDATE_ORDER_BANNER',
    CHANGE_ACTIVATION: 'CHANGE_ACTIVATION',
    SET_SHOW: 'SET_SHOW',
    UPLOAD_BANNER: 'UPLOAD_BANNER',
    DELETE_BANNER: 'DELETE_BANNER',
    UPDATE_BANNER: 'UPDATE_BANNER'
}